import StringValidator from '@core/scripts/helper/string-validator';

const UNEXPECTED_CHARACTERS_PATTERNS = /([^\p{L}\d ()/,.\-+]+)/gu;
const URL_PATTERN = /(((http|www)[^ ]*( |$))|[\\p{IsAlphabetic}\\d-]+\\.[\\p{IsAlphabetic}\\d-]{2,})/g;
const EMAIL_PATTERN = /(( |^)[^ ]*@[^ ]*)/g;
const PHONE_NUMBER_PATTERN = /((?!9)[+0]?[\d /-]{8,}\d)/g;

export const cleanSearchValue = (searchValue) => {
    return searchValue
        .replace(URL_PATTERN, '')
        .replace(EMAIL_PATTERN, '')
        .replace(PHONE_NUMBER_PATTERN, '')
        .replace(UNEXPECTED_CHARACTERS_PATTERNS, '')
        .trim();
}

export const isValidSearchValue = (searchValue) => {
    return new StringValidator(searchValue).isNotEmpty().isValid()
}